export default __webpack_public_path__ + "static/media/iOS.e8b6fc60.png";